import { fmt4 } from "../constants";

export default function ModalAlertaVinculo({ alertaVinculo, setAlertaVinculo, confirmarPreco }) {
  if (!alertaVinculo) return null;
  return (
    <div className="overlay-modal">
      <div style={{background:"#fff",borderRadius:8,padding:24,maxWidth:440,width:"90%",boxShadow:"0 8px 32px rgba(0,0,0,0.2)"}}>
        <div style={{fontSize:15,fontWeight:700,marginBottom:12}}>Atualizar preco de custo?</div>
        <div style={{fontSize:13,marginBottom:16,color:"var(--z-text-secondary)"}}>
          <strong>{alertaVinculo.produtoCodigo} — {alertaVinculo.produtoNome}</strong>
          <div style={{marginTop:8,display:"flex",gap:16}}>
            <span>Atual: <strong className="text-danger">R$ {fmt4(alertaVinculo.precoAtual)}</strong></span>
            <span>Novo: <strong className="text-success">R$ {fmt4(alertaVinculo.precoNovo)}</strong></span>
          </div>
        </div>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button className="btn btn-secondary" onClick={()=>setAlertaVinculo(null)}>Manter atual</button>
          <button className="btn btn-primary" onClick={async()=>{
            await confirmarPreco(alertaVinculo.itemId);
            setAlertaVinculo(null);
          }}>Atualizar e propagar</button>
        </div>
      </div>
    </div>
  );
}
